<template>
  <Modal @close="closeModal">
    <template v-slot:body>
      <div>
        <h1 class="mb-5">Update Barrel Name</h1>
        <v-row align="center" justify="center">
          <v-col>
            <v-text-field
              v-model="newName"
              :placeholder="barrelName"
              :rules="barrelNameRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <ConfirmationModal
        :isLoadingConfirmation="loadingConfirmation"
        :isShowDialog="isShowConfirmationModal"
        :btnConfig="buttonConfiguration"
        :inputInfo="confirmationModalInfo"
        :inputColor="confirmationModalInfoColor"
        @eConfirm="updateBarrelName"
        @eCancel="defaultCancelOperation"
      />
      <SnackbarNotifier
        :isShow="isShowSnackBar"
        :message="responseMessage"
        :snackType="snackbarType"
        :colour="snackBarColour"
        @eReset="resetSnackBar"
      />
    </template>
    <template v-slot:footer>
      <button class="btn btn-secondary" @click="closeModal">Cancel</button>
      <button class="btn btn-primary" :disabled="updateBtnDisabled" @click="updateNameConfirmation">
        <span v-if="!updatingName">OK</span>

        <v-progress-circular
              width="2"
              size="25"
              v-if="updatingName"
              indeterminate
              color="primary"
            ></v-progress-circular>
      </button>
    </template>
  </Modal>
</template>

<script>
import mixins from "vue-typed-mixins";
import Modal from "@/components/Modal.vue";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
export default mixins(ConfirmationModalMixin,SnackbarNotifierMixin).extend({
  name: 'UpdateBarrelName',
  components: {Modal,ConfirmationModal,SnackbarNotifier},
  props: {
    logicalBarrelId: {
      type: String,
      required: true
    },
    barrelName: {
      type: String,
      required: true
    }
  },
  data: () => ({
    newName: '',
    updatingName: false
  }),
  computed: {
    barrelNameRules(){
      return [
        (name) => !!name || 'Barrel name is required',
        (name) => !(name.toLowerCase() === this.$props.barrelName.toLowerCase()) || 'Barrel name is currently the same.'
      ]
    },
    updateBtnDisabled(){
      return !this.newName || this.$props.barrelName.toLowerCase() === this.newName.toLowerCase();
    }
  },
  methods: {
    closeModal(){
      this.$emit('closeModal');
    },
    updateNameConfirmation(){
      this.showConfirmationModal({
        title: 'Update Barrel Name',
        message: `Are you sure you want to rename <strong><em>${this.$props.barrelName}</em></strong> to <strong><em>${this.newName}</em></strong>?`,
        confirmButtonTitle: 'Yes'
      })
    },
    async updateBarrelName(){
      try{
        this.startConfirmationLoading();
        this.updatingName = true;
        await ApiService.Instance.updateBarrelName({
          logicalBarrelId: this.$props.logicalBarrelId,
          name: this.newName.trim()
        })
        this.stopConfirmationLoading();
        this.updatingName = false;
        this.$emit('successfulUpdate');
      }
      catch(err){
        this.showNotifier({
          message: 'Failed To Update Barrel Name',
          snackbarType: 'error'
        })
        this.stopConfirmationLoading();
        this.updatingName = false;
        error('updateBarrelName');
        error(err)
      }
    }
  }

})
</script>